import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Link } from "react-router-dom";
import classNames from 'classnames';
import withTranslations from '../../translations';

import { rootUrl } from '../../constants/urls';

import Paper from '../base/Paper/Paper';
import Avatar from '../base/Avatar/Avatar';
import Chip from '../base/Chip/Chip';
import Typography from '../base/Typography/Typography';

import Clear from '@material-ui/icons/Clear';

const styles = theme => ({
  root: {
    marginLeft: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(4),
    },
  },
  flex: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(4),
    },
  },
  paper: {
    padding: `${theme.spacing(3)}px ${theme.spacing(3)}px ${theme.spacing(4)}px`,
    minHeight: 300,
    maxWidth: `calc(100vw - ${theme.spacing(4)}px)`,
    marginBottom: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      padding: `${theme.spacing(4)}px ${theme.spacing(3)}px ${theme.spacing(4)}px`,
      maxWidth: 650,
    },
  },
  backlink: {
    '&:visited': {
      color: theme.palette.text.primary,
    },
  },
  title: {
    margin: `${theme.spacing(4)}px ${theme.spacing()}px`,
  },
  avatar: {
    height: 80,
    width: 80,
    margin: `0px auto ${theme.spacing(3)}px`,

    '& svg': {
      fontSize: 30,
    },

    [theme.breakpoints.up('sm')]: {
      height: 120,
      width: 120,
      fontSize: 30,

      '& svg': {
        fontSize: 50,
      },
    },
  },
  dl: {

    '& dt': {
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(),
      fontSize: theme.typography.fontSize * 0.875,
    },

    '& dd': {
      marginBottom: theme.spacing(2.5),
      marginLeft: 0,
      borderBottom: '1px dashed #CCC',

      [theme.breakpoints.up('sm')]: {
        marginBottom: theme.spacing(3.5),
      },
    },
  },
  chip: {
    marginRight: theme.spacing(),
    marginBottom: theme.spacing(0.5),
  },
})

const Profile = ({ classes: c, t, gt, children, history, data }) => {
  const {
    firstName,
    lastName,
    role,
    company,
    permissions,
    customerCenters,
    productCenters,
    serviceTechnologyCenters,
    distributors
  } = data;

  const allCenters = [
    ...customerCenters,
    ...productCenters,
    ...serviceTechnologyCenters,
    ...distributors
  ];

  const name = `${firstName} ${lastName}`;

  function renderCenters(centers) {
    return centers && centers.length
      ? centers.map(center => <Chip className={c.chip} key={center.code} label={center.name} />)
      : null
  }

  return (
    <div className={classNames('fars-profile', c.root)} >
      <div className={c.flex}>
        <Link className={c.backlink} to={rootUrl()} >
          <Clear />
        </Link>
        <Typography variant='h4' className={c.title}>{t.title}</Typography>
      </div>
      <Paper className={c.paper}>
        <Avatar
          className={c.avatar}
          user={name}
        />
        <dl className={c.dl}>
          <dt>{t.name}</dt>
          <dd>{`${firstName} ${lastName}`}</dd>

          <dt>{t.role}</dt>
          <dd>{role.id && gt.Roles[role.id]}</dd>

          <dt>{t.company}</dt>
          <dd>{company}</dd>

          <dt>{t.rights}</dt>
          <dd>
            { permissions && permissions.length
              ? permissions.map(p => <p key={p}>{gt.Permissions[p]}</p>)
              : null
            }
          </dd>

          <dt>{t.linked}</dt>
          <dd>{renderCenters(allCenters)}</dd>

        </dl>
      </Paper>
    </div>
  );
}

export const ProfileStory = withStyles(styles)(withTranslations(Profile, 'Profile'))

export default withRouter(withStyles(styles)(withTranslations(Profile, 'Profile')));



// WEBPACK FOOTER //
// ./src/components/Profile/Profile.js